interface KV {
  key: string;
  value: string;
  /** Monospace for citations / IDs */
  mono?: boolean;
  /** data-testid suffix for the value cell */
  testId?: string;
}

interface KeyValueGridProps {
  items: KV[];
}

export function KeyValueGrid({ items }: KeyValueGridProps) {
  return (
    <dl className="grid grid-cols-[180px_1fr] gap-y-1 gap-x-4 text-sm">
      {items.map((item) => (
        <div key={item.key} className="contents">
          <dt className="text-xs uppercase tracking-wider text-gray-500 dark:text-slate-400 self-center">
            {item.key}
          </dt>
          <dd
            data-testid={item.testId}
            className={
              item.mono
                ? 'font-mono text-sm text-gray-900 dark:text-slate-100 break-all'
                : 'text-gray-900 dark:text-slate-100'
            }
          >
            {item.value}
          </dd>
        </div>
      ))}
    </dl>
  );
}
